App.namespace.wrap('components.enquiry_tracking', (source, isUserLoggedIn, label = null) => {
  const CATEGORY = 'enquiry';
  const ACTION = `${isUserLoggedIn ? 'user' : 'guest'}-${source}`;

  App.track.custom(window.__DATA_TRACKING_CUSTOM_EVENTS, {
    category: CATEGORY,
    action: ACTION,
  }, {
    once: true,
  });
});
